export default __webpack_public_path__ + "assets/carousel-next.30064ba5.svg";